import { v4 as uuidv4 } from 'uuid';

import { actions } from 'src/constants';
import { createResource, getActionType } from 'src/core/redux/actions';

export const uploadFile = (payload) => (dispatch) => {
  const fileId = uuidv4();
  const file = {
    id: fileId,
    name: payload.name,
    path: payload.path,
    size: payload.size,
    type: payload.type
  };

  return dispatch(
    createResource({ NAME: 'file' }, actions.ACTION_UPLOAD)(file,
      {
        url: '/mcp/custom-projects-upload-file',
        requestId: fileId
      })
  );
};

export const removeFileData = (fileId = '') => ({
  type: getActionType(actions.REMOVE_FILE_DATA, 'files'),
  data: {},
  fileId,
});
